export const environment = {
	production: true,
	sentryEnvironment: 'production',
	imageKit: {
		publicKey: 'public_zfTY7SNcj1G9tkAoZhHcwp7ndPw=',
		urlEndpoint: 'https://ik.imagekit.io/xcvc8g230'
	},
	hubspot: {
		HUBSPOT_API_KEY: 'na2-438e-1b19-49c1-9f6f-40a2c91bd95f',
		HUBSPOT_ACCESS_TOKEN: 'pat-na2-5db8d6a0-374c-41d9-967d-05c76136d0d9',
		HUBSPOT_CLIENT_SECRET: '5a3f5294-a011-408e-981e-03c6aec0a730',
		HUBSPOT_PORTAL_ID: '48921432',
		HUBSPOT_FORM_ID: '935ecec1-484c-45b4-ba9c-8abde6a7ee5e'
	},
	contentful_config: {
		space: 'uwpg4vevsh2j',
		accessToken: 'UYJms2qgmqnH79pJc1cw8yA8ihnYU8XlpWD_fTzUsT4',
		environment: 'master',
		contentTypeIds: {
			aboutPage: 'aboutPage',
			privacyPolicyPage: 'privacyPolicyPage',
			termsAndConditionsPage: 'termsAndConditionsPage',
			termsOfUsePage: 'termsOfUsePage',
			contactPage: 'contactPage',
			homePage: 'homePage',
			capabilitiesPage: 'capabilitiesPage',
			careersPage: 'careersPage',
			workPage: 'workPage',
			newsPage: 'newsPage',
			work: 'work',
			clients: 'clients',
			spot: 'spot',
			news: 'news'
		}
	}
};
